import React from "react";

// CR-578: shown instead of the megaphone when the candidate has an active contract.
// Uses the megaphone pink (#e55496); width/height sized in vw to line up with the
// "Available for work" icon.
const WorkingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="#e55496"
      style={{ width: "3.5vw", height: "8vw", marginTop: "-2vw",  marginRight:"2vw", marginLeft:"0.5vw" }}
    >
      <path d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 48V56C128 25.1 153.1 0 184 0H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64v96H0V160c0-35.3 28.7-64 64-64h64zM0 288H192v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288H512V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288z" />
    </svg>
  );
};

export default WorkingIcon;
